module.exports = __webpack_public_path__ + "img/homebg.70afc450.png";